<template>
   <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    >
      <mobile-menu slot="content"></mobile-menu>

      <sidebar-link to="/maps">
        <md-icon>location_on</md-icon>
        <p>  Parcelles  </p>
      </sidebar-link>

      <sidebar-link to="/table">
        <md-icon>content_paste</md-icon>
        <p>Parcelles Liste</p>

      
      </sidebar-link>


      <sidebar-link to="/Add">
        <md-icon>add_circle</md-icon>
        <p>  Ajouter une parcelle  </p>
     
      </sidebar-link>

      <sidebar-link to="/user">
        <md-icon>person</md-icon>
        <p>Utilisateur


        </p>


      </sidebar-link>

      <sidebar-link to="/notifications">
        <md-icon>notifications</md-icon>
        <p>Notifications</p>
      </sidebar-link>


   
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content></dashboard-content>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div> 


 


</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";
import FixedPlugin from "./Extra/FixedPlugin.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu,
    // FixedPlugin
  },
  data() {
    return {
      sidebarBackground: "green",
      sidebarBackgroundImage: require("@/assets/img/sidebar-5.jpg"),
    };
  },
  methods: {
    logout() {
      this.socket = io("https://tomatocount.tk/irrig_all/", {
        query: { user: localStorage.getItem("authToken") },
      });
      this.socket.emit("logout", { id: localStorage.getItem("authToken") });
      localStorage.removeItem("authToken");
      router.push("/login");
      //  router.push('/login')
    },
  },
};
</script>
